import * as _ from 'lodash';

abstract class BaseComponentSingleton {
  protected static _instance: BaseComponentSingleton;

  /**
   * @see https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
   */
  ['constructor']: typeof BaseComponentSingleton;

  constructor(public rootElement: HTMLElement) {
    if (this.constructor._instance) {
      if (process.env.NODE_ENV === 'development') {
        console.warn(
          `[${this.constructor.name}]: Initializing multiple instances of singleton class, only the first one will be created.`,
        );
      }

      return this.constructor._instance;
    }

    this.constructor._instance = this;

    setTimeout(() => {
      this._init();
    }, 0);
  }

  protected _init = _.once(() => {
    return this.init();
  });

  public abstract init(): void;
}

export { BaseComponentSingleton };
